export const workoutQueryKeys = {
  all: () => "workout"
};
